import { useFetch } from "lib/useFetch";
import { setParam, push } from "pages/search/api/filterUrlMaker";
import { generateBody } from "./generateBody";
import { useQueryParams } from "../../../lib/hooks/useQueryParams";

const COVERAGE_URL = "/research/japi/coverage/search";

export const useCoverageData = () => {
  const queryString = useQueryParams();
  const [data, isLoading, isError] = useFetch(COVERAGE_URL, generateBody(queryString), "POST");
  const { rows, hits } = tryParseRows(data);
  return { rows, hits, isLoading, isError, onPage };
};

export const tryParseRows = (data) => {
  try {
    if (!data || !data.hits || !data.hits.hits) return {};
    const rows = data.hits.hits.map(({ _source }) => _source);
    const hits = data.hits.total.value;
    return { rows, hits };
  } catch (err) {
    console.error("Error parsing coverage rows from server", err, data);
    return {};
  }
};

const onPage = (page) => {
  push(setParam("Page", page));
};
